import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { initializeApp } from "firebase/app";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import "./styles/productDetails.css";

const firebaseConfig = {
  apiKey: "AIzaSyDO-ivCiTJcGRD4ZQVxEefflp8dXigy_Fo",
  authDomain: "hellocar-777.firebaseapp.com",
  projectId: "hellocar-777",
  storageBucket: "hellocar-777.appspot.com",
};

initializeApp(firebaseConfig);
const db = getFirestore();

export default function ProductDetails() {
  const [product, setProduct] = useState({});
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  const id = searchParams.get("id");
  const restoredFilters = location.state?.filters || "";

  useEffect(() => {
    const fetchProduct = async () => {
      const ref = doc(db, "helloCarProducts", id);
      const snap = await getDoc(ref);
      if (snap.exists()) setProduct(snap.data());
    };
    fetchProduct();
  }, [id]);

  const specs = Array.isArray(product.specs) ? product.specs : [];

  const backURL = restoredFilters ? `/products?${restoredFilters}` : "/products";

  /* ✅ Scroll reveal animations */
  useEffect(() => {
    const items = document.querySelectorAll(
      ".reveal, .reveal-left, .reveal-right"
    );

    const obs = new IntersectionObserver(
      entries =>
        entries.forEach(entry => {
          if (entry.isIntersecting) entry.target.classList.add("active");
        }),
      { threshold: 0.2 }
    );

    items.forEach(i => obs.observe(i));

    return () => obs.disconnect();
  }, []);

  return (
    <div className="product-container reveal">

      {/* ✅ Back Button */}
      <button className="back-btn reveal-left" onClick={() => navigate(backURL)}>
        ← Back to Products
      </button>

      <div className="product-top">

        {/* ✅ Product Image */}
        <div className="product-image reveal-left">
          <img
            src={`https://drive.google.com/thumbnail?id=${product.img}&sz=w1000`}
            alt={product.name || "product"}
          />
        </div>

        <div className="vertical-line reveal"></div>

        {/* ✅ Details */}
        <div className="product-details reveal-right">
          <h1>{product.name}</h1>

          <div className="auto-details">
            {Object.entries(product)
              .filter(([key, value]) =>
                key !== "img" &&
                key !== "specs" &&
                value !== "" &&
                value !== null &&
                value !== undefined
              )
              .map(([key, value]) => (
                <p key={key}>
                  <b className="auto-label">
                    {key
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, (c) => c.toUpperCase())}:
                  </b>{" "}
                  {Array.isArray(value) ? value.join(", ") : value.toString()}
                </p>
              ))}
          </div>

          {/* ✅ Contact Dealer */}
          <p style={{ marginTop: "20px" }}>
            <a href="https://wa.me/9899208565">
              For purchasing or more details, contact Dealer:
              <br /> +91 98992 08565
            </a>
          </p>
        </div>
      </div>

      {/* ✅ Specs */}
      <div className="product-specs reveal active">
        <p>Specifications:</p>
        <ul>
          {specs.map((spec, i) => (
            <li key={i}>
              {spec}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
